import userDetailsImg from './user-details.png'
import userListImg from './users-list.png'

export const images = {
  userDetailsImg,
  userListImg,
}
